import React, { useRef, useEffect } from 'react';
import { NEUTRAL, onAccent } from './designTokens';

// T-13: kundens meddelanden. Bubblor (egna i accent, terapeutens vita), datumavdelare,
// "Läst" på senaste egna lästa meddelande, skrivfält med rund skicka-knapp.
// Sidhuvudet ritas av ClientView (ClientHero).

const MONTHS_SHORT = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
const dateKey = (iso) => iso.slice(0, 10);

function dayLabel(iso) {
  const d = new Date(iso);
  const today = new Date(); const y = new Date(); y.setDate(y.getDate() - 1);
  const k = dateKey(d.toISOString());
  if (k === dateKey(today.toISOString())) return 'Idag';
  if (k === dateKey(y.toISOString())) return 'Igår';
  return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
}

function ClientMessagesTab({
  messages,
  messagesLoading,
  newMessage,
  setNewMessage,
  sendMessage,
  brandAccent,
}) {
  const scrollRef = useRef(null);
  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages]);

  const accentText = onAccent(brandAccent);
  const lastReadOwn = [...messages].reverse().find(m => m.sender_role === 'client' && m.read);

  return (
    <div style={{ background: NEUTRAL.card, border: `1px solid ${NEUTRAL.line}`, borderRadius: '14px', boxShadow: '0 1px 3px rgba(10,7,6,0.04)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div ref={scrollRef} style={{ padding: '16px', height: 'min(460px, 55vh)', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px', background: NEUTRAL.page }}>
        {messagesLoading ? (
          <div style={{ margin: 'auto', color: NEUTRAL.muted, fontSize: '13px' }}>Laddar…</div>
        ) : messages.length === 0 ? (
          <div style={{ margin: 'auto', textAlign: 'center', padding: '0 24px' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', color: NEUTRAL.ink, marginBottom: '4px' }}>Direktkanal till din terapeut</div>
            <div style={{ fontSize: '12px', color: NEUTRAL.muted, lineHeight: 1.6 }}>Ställ frågor, berätta hur det går eller hör av dig när du behöver stöd. Skriv nedan för att börja.</div>
          </div>
        ) : messages.map((msg, i) => {
          const mine = msg.sender_role === 'client';
          const prev = messages[i - 1];
          const showDay = !prev || dateKey(prev.created_at) !== dateKey(msg.created_at);
          const time = new Date(msg.created_at).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
          return (
            <React.Fragment key={msg.id}>
              {showDay && <div style={{ textAlign: 'center', fontSize: '11px', color: NEUTRAL.faint, margin: '6px 0 2px' }}>{dayLabel(msg.created_at)}</div>}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: mine ? 'flex-end' : 'flex-start' }}>
                <div style={{ padding: '10px 14px', borderRadius: mine ? '14px 14px 4px 14px' : '14px 14px 14px 4px', maxWidth: '80%', background: mine ? brandAccent : NEUTRAL.card, color: mine ? accentText : NEUTRAL.ink, border: mine ? 'none' : `1px solid ${NEUTRAL.line}`, fontSize: '14px', lineHeight: 1.45, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {msg.content}
                </div>
                <div style={{ fontSize: '11px', color: NEUTRAL.faint, marginTop: '3px', padding: mine ? '0 4px 0 0' : '0 0 0 4px' }}>
                  {time}{mine && lastReadOwn && lastReadOwn.id === msg.id ? ' · Läst' : ''}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <form onSubmit={sendMessage} style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', padding: '10px 12px', borderTop: `1px solid ${NEUTRAL.line}`, background: NEUTRAL.card }}>
        <label htmlFor="client-msg" style={{ position: 'absolute', left: '-9999px' }}>Skriv meddelande</label>
        <input
          id="client-msg"
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Skriv ett meddelande…"
          style={{ flex: 1, minWidth: 0, padding: '11px 14px', borderRadius: '12px', border: `1px solid ${NEUTRAL.line}`, fontSize: '14px', outline: 'none', background: NEUTRAL.card, fontFamily: 'inherit', color: NEUTRAL.ink }}
        />
        <button type="submit" aria-label="Skicka" disabled={!newMessage.trim()} style={{ width: '42px', height: '42px', borderRadius: '12px', background: brandAccent, border: 'none', color: accentText, fontSize: '18px', cursor: newMessage.trim() ? 'pointer' : 'default', opacity: newMessage.trim() ? 1 : 0.5, flexShrink: 0, fontFamily: 'inherit' }}>↑</button>
      </form>
    </div>
  );
}

export default ClientMessagesTab;
